
import React, { useState, Fragment } from 'react';
import { Typography, Button, Popover, Box } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import CreateFolderPopup from './create-folder-popup';
import {
    usePopupState,
    bindToggle,
} from 'material-ui-popup-state/hooks'
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
const useStyles = makeStyles((theme) => ({
    btnCreat: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: "0.36px",
        color: "#ffffff",
    }, btnCreatSelect: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: "0.36px",
        color: "#237fc2",
    }, borderButton: {
        borderRadius: '10px',
        border: 'solid 1px #c1e5fa',
        color: "#ffffff"
    },
    borderButtonSelect: {
        borderRadius: '10px',
        border: 'solid 1px #c1e5fa',
        backgroundColor: ' #ffffff',
        color: "#237fc2"
    }

}));

function Index({ setSnackbarMessage, categoryId, getCategory }) {
    const translate = useTranslate();
    const popupState = usePopupState({ variant: 'popper', popupId: 'createPopup' })
    const classes = useStyles();

    const onCreateFolderSuccess = (key, name) => {
        const message = translate(key);
        popupState.close()
        setSnackbarMessage({
            message,
            boldText: name
        });
        getCategory(categoryId);

        // Close snackbar message
        setTimeout(() => {
            setSnackbarMessage({
                message: '',
                boldText: ''
            });
        }, 6000);
    }

    return (
        <Fragment>
            <Button
                aria-describedby={"simple-popover"}
                variant="contained"
                color='primary'
                className={!popupState.isOpen ? classes.borderButton : classes.borderButtonSelect}
                // color={isCreateFolderPopoverOpen===false?"primary":"#237fc2"}
                endIcon={<Add></Add>}
                {...bindToggle(popupState)}
            >
                <Typography className={!popupState.isOpen ? classes.btnCreat : classes.btnCreatSelect}>{translate('pos.categories.createBtn')}</Typography>
            </Button>
            <CustomPopoverArrow
                zIndex={10000}
                popupState={popupState}
                placement='bottom-end'
            >
                <CreateFolderPopup
                    onCreateFolderSuccess={onCreateFolderSuccess}
                    parentId={categoryId}
                    close={popupState.close}
                />
            </CustomPopoverArrow>

        </Fragment>
    );
}

Index.propTypes = {
    categoryId: PropTypes.number,
    setSnackbarMessage: PropTypes.func.isRequired,
    getCategory: PropTypes.func.isRequired,
};

export default Index;
